import React, { useEffect, useState } from "react";
import { IInsights, fetchInsightsApiCall } from "./InsightsController";
import usePaginationHook from "../../hooks/UsePaginationHook";
import { PAGINATION_PER_PAGE_ROWS } from "../../utils/AppConstants";
import { IPagination } from "../../data/AppInterface";
import { useNavigate } from "react-router-dom";
import InsightViewSkeleton from "../insights/insights-skeleton/InsightsViewSkeleton";
import PaginationFooter from "../../components/page-layouts/PaginationFooter";
import UseTranslationHook from "../../hooks/UseTranslationHook";
import InsightCard from "./InsightCard";

interface IInsightGrid {
  categoryId: number | null;
  enterpriseSearch?: string;
  activePagination?: boolean;
}
const InsightGrid: React.FC<IInsightGrid> = ({
  categoryId,
  enterpriseSearch,
  activePagination,
}) => {
  const [insightsList, setInsightsList] = useState<IInsights[]>([]);
  const [buffer, setBuffer] = useState(true);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState<boolean>(false);
  const { t } = UseTranslationHook();
  let timer: NodeJS.Timeout;
  const { pagination, setPagination } = usePaginationHook({
    pagination: {
      per_page_rows: Number(PAGINATION_PER_PAGE_ROWS.Nine),
      current_page: 1,
      sort_by: "",
      order_by: "DESC",
    },
  });
  const fetchInsightList = async (
    payloadPagination: IPagination,
    insights: IInsights[],
    categoryId: number | null
  ) => {
    await fetchInsightsApiCall(
      setInsightsList,
      setLoading,
      setPagination,
      payloadPagination,
      insights,
      setBuffer,
      {
        enterpriseSearch,
      },
      categoryId
    );
  };
  useEffect(() => {
    fetchInsightList(
      { ...pagination, current_page: 1 },
      insightsList,
      categoryId
    );
  }, [categoryId, enterpriseSearch]);

  return (
    <div className="h-full">
      <div className="grid grid-cols-12 gap-6  mb-4 transition-all duration-200">
        {insightsList.length > 0 && loading ? (
          [...Array(9)].map((_, index) => <InsightViewSkeleton key={index} />)
        ) : insightsList.length > 0 ? (
          insightsList.map((item, index) => (
            <InsightCard item={item} key={index} />
          ))
        ) : (
          <div className="text-white col-span-12 text-center">
            {t("no_blog")}
          </div>
        )}
      </div>

      {pagination.total_page > 1 && (
        <div className="mb-5">
          <PaginationFooter
            pagination={pagination}
            active={active}
            handleChangePerPageRows={(perPageRow) =>
              fetchInsightsApiCall(
                setInsightsList,
                setLoading,
                setPagination,
                {
                  ...pagination,
                  per_page_rows: perPageRow,
                  current_page: 1,
                },
                insightsList,
                setBuffer,
                {
                  enterpriseSearch,
                },
                categoryId
              )
            }
            handleChangePage={(page) =>
              fetchInsightsApiCall(
                setInsightsList,
                setLoading,
                setPagination,
                { ...pagination, current_page: page },
                insightsList,
                setBuffer,
                {
                  enterpriseSearch,
                },
                categoryId
              )
            }
          />
        </div>
      )}
    </div>
  );
};

export default InsightGrid;
